import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import ClientLayout from './components/ClientLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import ClientDetail from './pages/ClientDetail';
import Context from './pages/Context';
import QuickQuestions from './pages/QuickQuestions';
import ContactSubmissions from './pages/ContactSubmissions';
import AdminSettings from './pages/AdminSettings';
import ClientDashboard from './pages/ClientDashboard';
import ClientChatbotSettings from './pages/ClientChatbotSettings';
import ClientKnowledge from './pages/ClientKnowledge';
import ChatSessions from './pages/ChatSessions';
import ClientChatSessions from './pages/ClientChatSessions';
import ClientQuickQuestions from './pages/ClientQuickQuestions';
import ClientContactSubmissions from './pages/ClientContactSubmissions';
import SessionDetail from './pages/SessionDetail';
import LoadingSpinner from './components/LoadingSpinner';

function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  // Determine user role and redirect accordingly
  const isAdmin = user?.role === 'admin';
  const isClient = user?.role === 'user';

  return (
    <div className="App">
      <Routes>
        <Route 
          path="/login" 
          element={!user ? <Login /> : <Navigate to={isAdmin ? "/" : "/client"} />} 
        />
        
        {/* Admin Routes */}
        {isAdmin && (
          <Route 
            path="/" 
            element={<Layout />}
          >
            <Route index element={<Dashboard />} />
            <Route path="clients" element={<Clients />} />
            <Route path="clients/:id" element={<ClientDetail />} />
            <Route path="clients/:id/context" element={<Context />} />
            <Route path="clients/:id/quick-questions" element={<QuickQuestions />} />
            <Route path="clients/:id/contact-submissions" element={<ContactSubmissions />} />
            <Route path="chat-sessions" element={<ChatSessions />} />
            <Route path="chat-sessions/:sessionId" element={<SessionDetail />} />
            <Route path="admin/settings" element={<AdminSettings />} />
          </Route>
        )}

        {/* Client Routes */}
        {isClient && (
          <Route 
            path="/client" 
            element={<ClientLayout />}
          >
            <Route index element={<ClientDashboard />} />
            <Route path="chat-sessions" element={<ClientChatSessions />} />
            <Route path="chat-sessions/:sessionId" element={<SessionDetail />} />
            <Route path="quick-questions" element={<ClientQuickQuestions />} />
            <Route path="contact-submissions" element={<ClientContactSubmissions />} />
            <Route path="settings" element={<ClientChatbotSettings />} />
            <Route path="knowledge" element={<ClientKnowledge />} />
          </Route>
        )}

        {/* Default redirects */}
        <Route 
          path="/" 
          element={
            user ? (
              <Navigate to={isAdmin ? "/" : "/client"} />
            ) : (
              <Navigate to="/login" />
            )
          } 
        />
        <Route 
          path="*" 
          element={<Navigate to={user ? (isAdmin ? "/" : "/client") : "/login"} />} 
        />
      </Routes>
    </div>
  );
}

export default App;